// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"2c308e8d","265":"2792f472","521":"003920c2","582":"8fecc6cf","611":"b7359340","620":"1f9576dc","715":"6d456ab3","722":"e490a400","870":"e5130b7d"}[chunkId] + ".chunk.js";
};